import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { StopTravelStatus } from '../../../redux/type';
const formatTimingString = (timeCount: number) => {
  const setDb = (num: number) => {
    if (num < 10) {
      return '0' + num;
    } else {
      return '' + num;
    }
  };
  const hour = setDb(Math.floor((timeCount % 86400000) / 3600000));
  const minutes = setDb(Math.floor((timeCount % 3600000) / 60000));
  const seconds = setDb(Math.floor((timeCount % 60000) / 1000));
  return hour + ':' + minutes + ':' + seconds;
};

const ItemStation = (props: {
  time: number;
  status: StopTravelStatus;
  waitingTime?: number | null;
  arrivedTime?: number | null;
  estDepartTime?: string | null;
}) => {
  const { status, waitingTime, arrivedTime, estDepartTime } = props;
  const [timeLong, setTimeLong] = useState('');
  const [showOverTime, setShowOverTime] = useState(false);
  const [timeStamp, forceUpdate] = useState(0);
  let overTimeCount = 0;
  let timeout: any = null;
  useEffect(() => {
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        forceUpdate(Date.now());
      }
    });
  }, []);
  useEffect(() => {
    const fn = () => {
      const arrivedTimeStamp = arrivedTime
        ? new Date(arrivedTime).getTime()
        : 0;
      let timer =
        waitingTime && arrivedTimeStamp
          ? waitingTime * 60000 - (new Date().getTime() - arrivedTimeStamp)
          : 0;
      clearTimeout(timeout);
      if (timer < 0) {
        overTimeCount = Math.abs(timer);
      }
      if (timer >= 1000) {
        timer = timer - 1000;
        const timingString = formatTimingString(timer);
        setTimeLong(timingString);
      } else {
        // overTimeCount += 1000;
        overTimeCount =
          waitingTime && arrivedTimeStamp
            ? new Date().getTime() - arrivedTimeStamp - waitingTime * 60000
            : arrivedTimeStamp
              ? new Date().getTime() - arrivedTimeStamp
              : overTimeCount + 1000;
        const timingString = formatTimingString(overTimeCount);
        setTimeLong(timingString);
        setShowOverTime(true);
      }
      timeout = setTimeout(fn, 1000);
    };
    timeout = setTimeout(fn, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [status, timeStamp, waitingTime, arrivedTime]);
  return (
    <>
      {estDepartTime ? (
        <span
          style={{
            color: '#fff',
            lineHeight: '20px',
          }}
        >
          {estDepartTime}返程
        </span>
      ) : (
        <span
          style={{
            color: `${showOverTime ? '#FF574D' : '#0D85FF'}`,
            lineHeight: '20px',
          }}
        >
          {showOverTime ? `超时 ${timeLong}` : timeLong}
        </span>
      )}
    </>
  );
};
export default React.memo(ItemStation);
